'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';

var API_TRACKING_JOB_MATCHING = 'log-aggregator/v1/track-job-matching';
var trackingJobMatching = function (baseMsUrl, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (typeof window === 'undefined') {
                    return [2 /*return*/, false];
                }
                body.datetime = new Date().toISOString();
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(API_TRACKING_JOB_MATCHING), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                _a.sent();
                return [2 /*return*/, true];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { trackingJobMatching as default };
//# sourceMappingURL=jobMatching.js.map
